import gsap from 'gsap';

const SlideFadeInitial = (element) => {
  gsap.set(element, { y: 80, autoAlpha: 0 });
};

export default SlideFadeInitial;
